/* Nav */
import FastClick from 'fastclick';

export default (el) => {
    const body = document.querySelector('body');

    const toggleItem = (event) => {
        event.preventDefault();
        body.classList.toggle('-navigation-active');
        el.classList.toggle('-active');
    };

    // Toggle item on mobile/tablet
    el.addEventListener('click', toggleItem);

    if ('addEventListener' in document) {
        document.addEventListener('DOMContentLoaded', function() {
            FastClick.attach(document.body);
        }, false);
    }
};
